import React from 'react';
import '../styles/Hero.css';
import heroBg from '../assets/images/hero-header-gold.png';
import iconChart from '../assets/images/icon-chart.png';
import iconLaptop from '../assets/images/icon-laptop.png';
import iconMagnify from '../assets/images/icon-magnify.png';
import iconRocket from '../assets/images/icon-rocket.png';
import iconShield from '../assets/images/icon-shield.png';
import iconTarget from '../assets/images/icon-target.png';

const Hero = () => {
  const services = [
    { label: 'Website Design', icon: iconLaptop },
    { label: 'SEO', icon: iconMagnify },
    { label: 'AI Automation', icon: iconRocket },
    { label: 'Google Ads', icon: iconChart },
    { label: 'CRM Systems', icon: iconShield },
    { label: 'Lead Generation', icon: iconTarget },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-bg-wrap">
        <img
            src={heroBg}
            alt=""
            className="hero-bg"
            width="1024"
            height="571"
            fetchpriority="high"
            decoding="async"
          />
        <div className="hero-overlay" aria-hidden="true" />
      </div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            We Build High-Converting Websites & AI Marketing Systems For Businesses Ready To Scale
          </h1>
          <p className="hero-subtitle">
            Digital Marketrix helps local and growing businesses turn their online presence into a lead-generation system with websites, SEO, ads, automation, and CRM strategy under one team.
          </p>
          <div className="hero-service-chips" aria-label="Core Digital Marketrix services">
            {services.map(({ label, icon }) => (
              <span key={label} className="hero-service-chip">
                <span className="hero-service-chip-icon-wrap" aria-hidden="true">
                  <img src={icon} alt="" className="hero-service-chip-icon" />
                </span>
                {label}
              </span>
            ))}
          </div>
          <div className="hero-cta">
            <button
              type="button"
              onClick={() => scrollToSection('contact')}
              className="btn btn-primary btn-lg"
            >
              Book Free Strategy Call
            </button>
            <button
              type="button"
              onClick={() => scrollToSection('contact')}
              className="btn btn-secondary btn-lg"
            >
              Get A Free Website Audit
            </button>
            <button
              type="button"
              onClick={() => scrollToSection('pricing')}
              className="btn btn-secondary btn-lg"
            >
              See Pricing
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
